import { render, staticRenderFns } from "./ClientsPlaceholder.vue?vue&type=template&id=08365b47&scoped=true&"
import script from "./ClientsPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ClientsPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ClientsPlaceholder.vue?vue&type=style&index=0&id=08365b47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08365b47",
  null
  
)

export default component.exports